export default "__VITE_ASSET__BHEDjTUR__"